/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useTransition, animated } from '@react-spring/web';
import clsx from 'clsx';
import React from 'react';

interface AccordionImageProps {
  children: React.ReactNode;
  reverse: boolean;
}

export const AccordionImageWrapper: React.FC<AccordionImageProps> = ({
  children,
  reverse,
}) => {
  const transition = useTransition([children], {
    immediate: true,
    from: { opacity: 0, x: 0, y: 0, top: 0, right: -150 },
    enter: { opacity: 1, x: 0, y: 0, top: 0, right: 0 },
    leave: { opacity: 0, x: 0, y: 0, top: 0, right: -20 },
  });

  return (
    <div
      className={clsx(
        'whl-relative whl-hidden whl-overflow-hidden lg:whl-block lg:whl-h-[530px] lg:whl-w-[50%] lg:whl-max-w-[530px]',
        `${reverse ? 'whl-order-1' : 'whl-order-2'}`,
      )}
    >
      {transition((style, item) => {
        return (
          item && (
            <animated.div
              className={
                'whl-absolute whl-hidden whl-duration-75 lg:whl-block lg:whl-h-full lg:whl-w-full xl:whl-h-full xl:whl-w-full'
              }
              style={style}
            >
              {children}
            </animated.div>
          )
        );
      })}
    </div>
  );
};
